import { render, staticRenderFns } from "./AppStateLabel.vue?vue&type=template&id=3f613856&scoped=true&"
import script from "./AppStateLabel.vue?vue&type=script&lang=js&"
export * from "./AppStateLabel.vue?vue&type=script&lang=js&"
import style0 from "./AppStateLabel.vue?vue&type=style&index=0&id=3f613856&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f613856",
  null
  
)

export default component.exports